
import React from "react";
import {MessegesComponent} from '../../../Messeges/Pages/Messeges'

export const CoachMessege = () => {
  return (
    <MessegesComponent jobSeek={false} />
  )
};
